import React, {useState} from 'react';
import {Button, Modal, ModalActions, ModalTitle} from "@deere/fuel-react";
import {CriteriaModalButton, CriteriaModalContent} from './modal/CriteriaModalDetail';
import {RatingsDeleteModal} from './modal/RatingsModalDetail';
import {SupplierModalButton, SupplierModalContent} from './modal/CampaignSupplierModal';
import {CampaignModalButton, CampaignModalContent} from './modal/CampaignModal';

export const ModalDialog = ({titleText, saveButtonText, content = {}, onSave, page, type}) => {
    const [open, setOpen] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState({});

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        setOpen(false);
        if (page === "Supplier")
            onSave(selectedSupplier)
        else onSave()
    }

    const handleSupplierSelect = (supplierObj) => {
        setSelectedSupplier(supplierObj);
    }

    const getButtonComp = (page) => {
        switch (page) {
            case "Criteria":
                return <CriteriaModalButton titleText={titleText} handleClickOpen={handleClickOpen} type={type}/>;
            case "Supplier":
                return <SupplierModalButton handleClickOpen={handleClickOpen}/>;
            case "Campaign":
                return <CampaignModalButton handleClickOpen={handleClickOpen}/>;
            case "Ratings":
                return <RatingsDeleteModal titleText={titleText} handleClickOpen={handleClickOpen} />;
            default:
                return <CriteriaModalButton titleText={titleText} handleClickOpen={handleClickOpen}/>;
        }
    }

    const getContentComp = (page) => {
        switch (page) {
            case "Criteria":
                return <CriteriaModalContent content={content}/>;
            case "Supplier":
                return <SupplierModalContent onContentChange={handleSupplierSelect}/>;
            case "Campaign":
                return <CampaignModalContent content={content}/>;
            default:
                return <CriteriaModalContent content={content}/>;
        }
    }

    return (
        <div>
            {getButtonComp(page)}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="sm"
                fullWidth={true}
            >
                <ModalTitle onClose={handleClose} id="alert-Modal-title">
                    {titleText}
                </ModalTitle>
                {getContentComp(page)}
                <ModalActions>
                    <Button onClick={handleClose} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={() => handleSave()} variant="primary">
                        {saveButtonText}
                    </Button>
                </ModalActions>
            </Modal>
        </div>
    );
};
